import { render } from "./GuiDiscountSelect.vue?vue&type=template&id=7c99aeae"
import script from "./GuiDiscountSelect.vue?vue&type=script&lang=js"
export * from "./GuiDiscountSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__